<template>
  <roe-error-message :field="design.s_147_employer_match_trueup_frequency">
    <v-select
      v-model="design.$model.s_147_employer_match_trueup_frequency"
      :options="[
        { code: 1, label: 'Per Payroll' },
        { code: 2, label: 'Monthly' },
        { code: 3, label: 'Quarterly' },
        { code: 4, label: 'Semi-Annual' },
        { code: 5, label: 'Annual' }
      ]"
      :reduce="label => label.code"
      required
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerMatchTrueUpFrequencySelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
